import { BaseApi } from './baseApi';
import { adaptListParams } from '../utils';
export default class FilterApi extends BaseApi {
    getFilter(id) {
        return this.apiCall({
            method: 'GET',
            route: `filter/${id}`,
        });
    }
    listFilters(params = {}) {
        return this.apiCall({
            method: 'GET',
            route: 'filter',
            params: Object.assign({}, adaptListParams(params)),
        });
    }
    updateFilter(id, data) {
        return this.apiCall({
            method: 'PATCH',
            route: `filter/${id}`,
            data,
        });
    }
    deleteFilter(id) {
        return this.apiCall({
            method: 'DELETE',
            route: `filter/${id}`,
        });
    }
    createFilter(data) {
        return this.apiCall({
            method: 'POST',
            route: 'filter',
            data,
        });
    }
}
//# sourceMappingURL=filterApi.js.map